import { appEventModule } from "app/event"
import { coordinateEventModule } from "coordinate/event"
import { formEventModule } from "form/event"
import { shapeEventModule } from "shape/event"
import { userEventModule } from "user/event"
import { changeMapsDistanceUnit, resetAllMaps, resizeAllMaps } from "./tools/common"
import { displayIntersectedGeoTargets, setGeoTargetsFeaturesFromform } from "./tools/geo-targets"
import {
  displayNewCoordinateFeature,
  removeCoordinateFeatures,
  setCoordinateFeatures,
  updateCoordinateFeature
} from "./tools/geo-targets-coordinate"
import { addShapesFeatures, deleteShapeFeatures, setShapesFeaturesForType } from "./tools/geo-targets-shape"

export function startMaplisteners(): void {
  coordinateEventModule.on.onCoordinateAdd("map-coordinate-add", coordinate => {
    displayNewCoordinateFeature(coordinate)
  })
  coordinateEventModule.on.onCoordinateUpdate("map-coordinate-update", coordinate => {
    updateCoordinateFeature(coordinate)
  })
  coordinateEventModule.on.onCoordinateDelete("map-coordinate-delete", coordinateId => {
    removeCoordinateFeatures([coordinateId])
  })
  coordinateEventModule.on.onCoordinatesDelete("map-coordinates-delete", coordinateIds => {
    removeCoordinateFeatures(coordinateIds)
  })
  coordinateEventModule.on.onCoordinatesSet("map-coordinates-set", coordinates => {
    setCoordinateFeatures(coordinates)
  })
  shapeEventModule.on.onShapesAdd("map-shapes-add", shapes => {
    addShapesFeatures(shapes)
  })
  shapeEventModule.on.onShapeDelete("map-shape-delete", shape => {
    deleteShapeFeatures([shape])
  })
  shapeEventModule.on.onShapesDelete("map-shapes-delete", shapes => {
    deleteShapeFeatures(shapes)
  })
  shapeEventModule.on.onShapesSet("map-shapes-set", params => {
    setShapesFeaturesForType(params.shapes, params.type)
  })
  formEventModule.on.geoTargetChange("map-form-geotarget-change", params =>
    displayIntersectedGeoTargets(params.intersectionFeature)
  )
  appEventModule.on.windowResize("map-window-resize", () => resizeAllMaps())
  userEventModule.on.logout("map-logout", () => resetAllMaps())
  formEventModule.on.formCleared("map-form-cleared", () => {
    // cleared is only used for creation forms, so here we just need to clear maps
    resetAllMaps()
  })
  appEventModule.on.appContextChange("map-app-context-change", newContext => {
    if (!newContext) {
      resetAllMaps()
    }
  })
  formEventModule.on.formOpened("map-form-opened", form => setGeoTargetsFeaturesFromform(form))
  formEventModule.on.formClosed("map-form-opened", () => resetAllMaps())
  formEventModule.on.summaryOpened("map-summary-opened", form => setGeoTargetsFeaturesFromform(form))
  formEventModule.on.summaryClosed("map-summary-opened", () => resetAllMaps())
  userEventModule.on.distanceUnitChange("map-distance-unit-change", params =>
    changeMapsDistanceUnit(params.newDistanceUnit, params.newDistanceUnit)
  )
}
